// extracted by mini-css-extract-plugin
export default {"titshare":"index_titshare_ku-AN","shareBox":"index_shareBox_q-BWT clearfix","boxhidden":"index_boxhidden_rdLkK"};